@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (taskMessage()) {
    <div class="taskMessage">
      <p>{{ taskMessage() }}</p>
    </div>
  }
  @if (task()) {
    <div class="taskDetail">
      <div class="displayRow">
        <span class="inputLabel">Task Name:</span>
        <span class="displayLabel">{{ task().name }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Started:</span>
        <span class="displayLabel">{{ task().startTime | date: 'M/d/yyyy hh:mm a' }}</span>
      </div>
      @if (task().escalationTime) {
        <div class="displayRow">
          <span class="inputLabel">Will Escalate:</span>
          <span class="displayLabel">{{ task().escalationTime | date: 'M/d/yyyy hh:mm a' }}</span>
        </div>
      }
      @if (task().autoCompleteTime) {
        <div class="displayRow">
          <span class="inputLabel">Will Autocomplete:</span>
          <span class="displayLabel">{{ task().autoCompleteTime | date: 'M/d/yyyy hh:mm a' }}</span>
        </div>
      }
      <div class="displayRow">
        <span class="inputLabel">Assigned To:</span>
        <span class="displayLabel">{{ assignedTo() }}</span>
      </div>
    </div>
  }
  @if (entity()) {
    <div class="entityDetail">
      <div class="displayRow">
        <span class="inputLabel">Entity ID:</span>
        <a class="displayLabel" [href]="getEntityUrl()">{{ entity().id.entityId + ';' + entity().id.entityRevision }}</a>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Project:</span>
        <span class="displayLabel">{{ entity().projectName }}</span>
      </div>
    </div>
  }
  @if (canCloseTask()) {
    <div class="notesSection">
      <div class="displayRow">
        <span class="inputLabel text-area-label">{{ notesLabel }}</span>
        <textarea rows="6" cols="80" class="no-resize" [(ngModel)]="notes" [disabled]="isBusy()"></textarea>
      </div>
    </div>
    <div class="buttonRow">
      <span class="inputLabel"></span>
      <button matButton="elevated" class="buttonInput approveButton" (click)="closeTask(true)">
        <span>
          <mat-icon class="size-16">done</mat-icon>
          <span class="buttonLabel">{{ approveLabel }}</span>
        </span>
      </button>
      <button matButton="elevated" class="buttonInput denyButton" (click)="closeTask(false)">
        <span>
          <mat-icon class="size-16">cancel</mat-icon>
          <span class="buttonLabel">{{ denyLabel }}</span>
        </span>
      </button>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <span class="busyLabel">Please Wait...</span>
    </div>
  </div>
}
